import React from 'react'
import {StyleSheet, TextProps} from 'react-native'
import Svg, {
  Defs,
  LinearGradient,
  Path,
  PathProps,
  Stop,
  SvgProps,
} from 'react-native-svg'
import {Image} from 'expo-image'

import {colors} from '#/lib/styles'
import {useKawaiiMode} from '#/state/preferences/kawaii'

const ratio = 57 / 64

type Props = {
  fill?: PathProps['fill']
  style?: TextProps['style']
} & Omit<SvgProps, 'style'>

export const Logo = React.forwardRef(function LogoImpl(props: Props, ref) {
  const {fill, ...rest} = props
  const gradient = fill === 'sky'
  const styles = StyleSheet.flatten(props.style)
  const _fill = gradient ? 'url(#sky)' : fill || styles?.color || colors.blue8
  // @ts-ignore it's fiiiiine
  const size = parseInt(rest.width || 32)

  const isKawaii = useKawaiiMode()

  if (isKawaii) {
    return (
      <Image
        source={
          size > 100
            ? require('../../../assets/kawaii.png')
            : require('../../../assets/kawaii_smol.png')
        }
        accessibilityLabel="Bluesky"
        accessibilityHint=""
        accessibilityIgnoresInvertColors
        style={[{height: size, aspectRatio: 1.4}]}
      />
    )
  }

  return (
    <Svg
      fill="none"
      // @ts-ignore it's fiiiiine
      ref={ref}
      viewBox="0 0 111.5 84.8"
      {...rest}
      style={[{width: size, height: size * ratio}, styles]}>
      {gradient && (
        <Defs>
          <LinearGradient id="sky" x1="0" y1="0" x2="0" y2="1">
            <Stop offset="0" stopColor="#0A7AFF" stopOpacity="1" />
            <Stop offset="1" stopColor="#59B9FF" stopOpacity="1" />
          </LinearGradient>
        </Defs>
      )}

      <Path
        fill={_fill}
        d="M73.4 58.6c-.9-1.4-3.3-.5-4.7 0-4.9 1.8-8.8 6.3-10.5 11.4-3.3 7.8 5.1 16.6 13 13 4-1.9 6.7-6.9 5.2-11.2-.7-2.6-3.1-3.8-5.1-5.2-1.9-2.2 2.1-5.3 2.2-7.8v-.2Z"
      />
      <Path
        fill={_fill}
        d="M52 58.6c-.9-1.4-3.3-.5-4.7 0-4.9 1.8-8.8 6.3-10.5 11.4-3.3 7.8 5.1 16.6 13 13 4-1.9 6.7-6.9 5.2-11.2-.7-2.6-3.1-3.8-5.1-5.2-1.9-2.2 2.1-5.3 2.2-7.8v-.2H52Z"
      />
      <Path
        fill={_fill}
        d="M87.6 72.6c-5.3-.5-6-7.9-1.3-9.6 2.1-.6 3.2-.2 5.7-1.3 5.3-2.3 9.6-8.7 8.5-14.6-.5-3.5-3.4-8.6-8.9-9.7-2.4-.5-4.3-2-5-4.3-.7-4.1-2.8-7.7-7.7-8.4-3.1-.7-7.1.4-10.4 3.7-.9 1-1.6 2-2.5 2.9-2.6 3.1-8 1.3-8.4-2.8-.4-3.4 2.9-6.2 5-8.3 9.5-8.8 26.5-7.8 32.2 5.4.3.7.6 1.5 1.1 2.1 24.8 11.1 15.8 43.8-8.2 44.8h-.2.1Zm5-45.1Z"
      />
      <Path
        fill={_fill}
        d="M22.2 72.7c-6.7 0-12-1.9-15.8-5.6C.5 61.3.8 53.1.9 50.4v-1.3c.3-10.5 6.6-18.9 17.4-23.2 1.3-12.8 10.6-19 12.1-20 14.2-9.6 28.7-2.9 34.3 2 2.1 1.8 2.3 5 .5 7.1a4.93 4.93 0 0 1-7 .5c-.5-.4-10.9-9-22.3-1.3l-.3.2c-.2.1-6.9 4.3-7.5 13.3-.2 3.3-2.3 6.1-5.3 7.2-5.3 1.9-11.7 6-11.9 14.7v1.2c0 1.8-.2 6.5 2.6 9.3 2 2 5.4 2.9 10.2 2.6 2.7 0 5.1 2 5.2 4.8s-2 5.1-4.8 5.2h-1.9ZM.9 49.3Z"
      />
    </Svg>
  )
})
